module.exports = __webpack_public_path__ + "img/couples-031.5a3587e4.jpg";